import { render } from "./account-pages.vue?vue&type=template&id=92e758b2"
import script from "./account-pages.vue?vue&type=script&lang=js"
export * from "./account-pages.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__